<div class="flex gap-2">
    <a *ngFor="let link of links" [href]="link.href" target="_blank" [style]="link.style">
        <app-icon [name]="link.iconName" />
    </a>
</div>
